import * as yup from "yup"
import { Atlante } from "../../types"

export function initialValuesAtlante(atlante?: Atlante | undefined) {
  if (atlante) {
    return atlante
  }
  return {
    nome: "",
    descrizione: "",
    immagine_copertina: undefined,
    informazioni_atlante: "",
    bozza: false,
  }
}

export function validationSchemaAtlante() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
  })
}
